import { ReactElement, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { ActionBar, ContentNode, ContentNodeRenderer, useHistoryPushWithBackAction } from '@dreryk/react-components';
import { TranslatableText } from '@dreryk/react-common';

import { visitTranslationKeys } from '../../translations';

import { StyledVisitActionBarItemTooltip } from './VisitActionBarItemTooltip.styled';

export type ActionBarDropdownOptionConfigItem = {
   label: ContentNode;
   path: string;
   id: string;
   disabled?: boolean;
   tooltipContent?: TranslatableText;
};

export const useActionBarDropdownItems = (config: ActionBarDropdownOptionConfigItem[]): ReactElement[] => {
   const push = useHistoryPushWithBackAction(false);
   const location = useLocation();

   return useMemo(
      () =>
         config
            .filter((configItem) => !matchPath(location.pathname, { path: configItem.path }))
            .map((configItem) => (
               <ActionBar.OptionalDropdown.Item
                  key={configItem.id}
                  testId={configItem.id}
                  onClick={(hide) => {
                     push(configItem.path, {
                        label: visitTranslationKeys.goBackToVisit,
                     });
                     hide();
                  }}
                  disabled={configItem.disabled}
               >
                  <StyledVisitActionBarItemTooltip
                     testId={configItem.id}
                     content={configItem.tooltipContent}
                     maxWidth={'400px'}
                     disabled={!configItem.tooltipContent || !configItem.disabled}
                  >
                     <ContentNodeRenderer node={configItem.label} />
                  </StyledVisitActionBarItemTooltip>
               </ActionBar.OptionalDropdown.Item>
            )),
      [config, push, location]
   );
};
